<template>
  <div>
    <div v-for="(skill, index) in feSkills" :key="index">
      <skill
        :img-location="skill.img_location"
        :year-experience="skill.year_experience"
        :rating="skill.rating"
        :heading="skill.heading"
      />
    </div>
    <div
      class="mt-10 text-sm text-center font-semibold text-gray-800 text-opacity-50 tracking-wider font-mono"
    >
      Also familliar with the Basics HTML,css,Js and Api integration
    </div>
  </div>
</template>
<script>
import Skill from "../widget/Skill";
export default {
  components: {
    Skill,
  },
  data() {
    return {
      feSkills: [
        {
          heading: "Vue.js",
          img_location: "/img/vue.png",
          year_experience: 2,
          rating: 7.5,
        },

        {
          heading: "Sass",
          img_location: "/img/sass.png",
          year_experience: 1,
          rating: 6.5,
        },
        {
          heading: "nuxt.js",
          img_location: "/img/nuxt.png",
          year_experience: 0.6,
          rating: 6.5,
        },
        {
          heading: "React",
          img_location: "/img/react.png",
          year_experience: 0.5,
          rating: 6,
        },
      ],
    };
  },
};
</script>